import { trackEvent } from 'helpers/Analytics';
import { IConciergeEmbedAiChat } from 'interfaces/concierge';
import React, { useEffect, useLayoutEffect } from 'react';

declare var embeddedservice_bootstrap: any;

export interface IConciergeEmbedAiChatProp {
  data: IConciergeEmbedAiChat;
}

const initEmbeddedMessaging = (data: IConciergeEmbedAiChat) => {
  try {
    embeddedservice_bootstrap.settings.language = 'en_US'; // For example, enter 'en' or 'en-US'

    embeddedservice_bootstrap.init(
      data?.chatCode,
      data?.chatTitle,
      data?.initBaseUrl,
      {
        scrt2URL: data?.scrt2Url,
      }
    );
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};

const AiLiveChat = ({ data }: IConciergeEmbedAiChatProp): JSX.Element => {
  const isHonda = process.env.REACT_APP_THEME === 'honda';

  useLayoutEffect(() => {
    initEmbeddedMessaging(data);
  }, [data]);

  useEffect(() => {
    const containerDisplay = isHonda ? 'block' : 'flex';
    const checkForEmbeddedSvc = setInterval(() => {
      if (embeddedservice_bootstrap.utilAPI) {
        clearInterval(checkForEmbeddedSvc);

        const onlineElement = document.getElementById(
          'liveagent_button_online_573o0000000PHe3'
        );
        const offlineElement = document.getElementById(
          'liveagent_button_offline_573o0000000PHe3'
        );
        if (onlineElement && offlineElement) {
          offlineElement.style.display = 'none';
          onlineElement.style.display = containerDisplay;
        }
      }
    }, 100);

    return () => clearInterval(checkForEmbeddedSvc);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    const handleBubbleTrack = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (target?.closest('.embeddedMessagingConversationButton')) {
        trackEvent({
          label: 'concierge:open live chat',
          category: { text: `:concierge live chat`, includePageName: true },
          type: 'selector',
        });
      }
    };
    document.body.addEventListener('click', handleBubbleTrack);
    return () => {
      document.body.removeEventListener('click', handleBubbleTrack);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default AiLiveChat;
